export default {
  'cashMovement.form.company': 'Empresas',
  'cashMovement.form.bankAccount': 'Contas Bancárias',
  'cashMovement.form.timeCourse': 'Período',
  'cashMovement.form.until': 'Até',
  'cashMovement.button.updateData': 'Atualizar Dados',
  'cashMovement.view.previousBalance': 'Saldo Anterior',
  'cashMovement.view.totalOutputs': 'Total Saídas',
  'cashMovement.view.totalEntries': 'Total Entradas',
  'cashMovement.view.totalBalance': 'Saldo Atual',

  'cashMovement.form.table.installmentCode': 'Código Parcela',
  'cashMovement.form.table.launch': 'Lançamento',
  'cashMovement.form.table.description': 'Descrição',
  'cashMovement.form.table.documentNumber': 'Número do documento',
  'cashMovement.form.table.entry': '(+) Entrada',
  'cashMovement.form.table.exit': '(-) Saída',
};
